import {React} from 'common'
import {Colors, Icons} from 'appearance'
import {useGetCurrentUserQuery, useI18n, useIsRtl} from 'store/Store'
import MenuItem from '@mui/material/MenuItem'
import Menu from '@mui/material/Menu'
import {Divider, Icon, ListItemIcon, styled, Typography} from '@mui/material'
import storage from 'services/storage'
import {getFullName} from 'services/utils/misc'
import {useNavigate} from 'react-router-dom'
import analyticsService from 'services/analytic'

const ProfileMenu = ({menuId, anchorEl, isMenuOpen, handleCloseMenu}) => {
    const {i18n} = useI18n()
    const isRtl = useIsRtl()
    const navigate = useNavigate()
    // const [doLogout] = useLogoutMutation()

    const {data: user} = useGetCurrentUserQuery()
    const name = getFullName(user)

    // const [doDeleteUser] = useDeleteUserMutation()

    const doLogout = () => {
        storage.setLoginCredentials(null)
        window.location.reload()
    }

    return (
        <Menu
            dir={isRtl ? 'rtl' : 'ltr'}
            MenuListProps={{style: {padding: 8, width: 188}}}
            anchorEl={anchorEl}
            id={menuId}
            open={isMenuOpen('profile')}
            onClose={handleCloseMenu('profile')}
            onClick={handleCloseMenu('profile')}>
            <UserName>{name}</UserName>
            <Divider />
            <StyledMenuItem
                onClick={() => {
                    navigate('/settings')
                    analyticsService.navToolPressed('settings')
                }}>
                <ListItemIcon>
                    <StyledIcon component={Icons.Settings} />
                </ListItemIcon>
                {i18n.t('profileMenu.settings')}
            </StyledMenuItem>
            <StyledMenuItem
                onClick={() => {
                    doLogout()
                    analyticsService.navToolPressed('logout')
                }}>
                <ListItemIcon>
                    <StyledIcon component={Icons.Logout} />
                </ListItemIcon>
                {i18n.t('profileMenu.logout')}
            </StyledMenuItem>
            {/* <StyledMenuItem
                onClick={() => doDeleteUser({accountKey: user.accountKey})}>
                <ListItemIcon>
                    <StyledIcon component={Icons.Logout} />
                </ListItemIcon>
                {i18n.t('profileMenu.delete')}
            </StyledMenuItem> */}
        </Menu>
    )
}

export default ProfileMenu

const UserName = styled(Typography)`
    padding: 8px;
`

const StyledMenuItem = styled(MenuItem)`
    padding: 6px 0;
`

const StyledIcon = styled(Icon)`
    background: ${Colors.ICONS_BACKGROUND};
    border-radius: 50px;
    height: 28.5px;
    width: 28.5px;
    padding: 2px;
`
